// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"71ef7765","667":"99825bbc"}[chunkId] + ".chunk.css";
};